module.exports = __webpack_public_path__ + "static/media/valor1.c87500bc.png";